export default __webpack_public_path__ + "static/media/logo-teomidia.6efe30f4.png";